<template>
  <b-row class="mt-2 justify-content-center">
    <b-col class="col-10 col-sm-8 col-md-6 col-lg-6 w-50">
      <small>
        <div class="spacer"></div>
        <br />
        <a href="mailto:prehospital@tigerconnect.com">prehospital@tigerconnect.com</a>
        <br />
        <a href="tel:+1(646) 968-0204">+1(646) 968-0204</a>
      </small>
      <div v-if="showFeedback" role="button" class="mt-4">
        <span @click="open"> Feedback </span>
      </div>
    </b-col>
  </b-row>
</template>

<script lang="ts">
import Vue from "vue";
import { mapActions } from "vuex";
export default Vue.extend({
  name: "ContactInfo",
  computed: {
    showFeedback: function () {
      return this.$route && this.$route.path !== "/";
    },
  },
  methods: {
    ...mapActions("FeedbackStore", ["open"]),
  },
});
</script>

<style scoped>
@media screen and (min-width: 601px) {
  .spacer {
    height: 45px;
  }
}
/* On screens that are 600px or less, set the background color to olive */
@media screen and (max-width: 600px) {
  .spacer {
    height: 0px;
  }
}
</style>
